import React from 'react';

import {ConnectionStatus, ConnectionStatusResponse} from 'instruments/connections/ConnectionConstants';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

interface DisableConnectionButtonProps {
  status: ConnectionStatusResponse | null;
  updateIsEnabled: (isEnabled: boolean) => void;
}

const CONNECTION_STATUS_TO_ICON: {[status in ConnectionStatus]: BenchlingIconName} = {
  [ConnectionStatus.AVAILABLE]: 'lock',
  [ConnectionStatus.INSTRUMENT_ERROR]: 'lock',
  [ConnectionStatus.COMMUNICATION_ERROR]: 'lock',
  [ConnectionStatus.DISABLED]: 'lock-open',
  [ConnectionStatus.PENDING]: 'lock',
  [ConnectionStatus.RUNNING]: 'lock',
  [ConnectionStatus.SERVICE_UNAVAILABLE]: 'lock',
};

const ICON_TO_SHOULD_ENABLE: {[key: string]: boolean} = {
  lock: false,
  'lock-open': true,
};

const ICON_TO_TOOLTIP: {[key: string]: string} = {
  lock: 'Disable connection',
  'lock-open': 'Enable connection',
};

export default function DisableConnectionButton(props: DisableConnectionButtonProps): JSX.Element {
  const iconName = props.status ? CONNECTION_STATUS_TO_ICON[props.status.value] : 'lock';
  const shouldEnable = ICON_TO_SHOULD_ENABLE[iconName];
  const tooltipText = ICON_TO_TOOLTIP[iconName];

  return (
    <Tooltip container="body" placement={TooltipPlacement.TOP} title={tooltipText}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_BLUE}
        className="metadata-header-button-spacing-left"
        icon={iconName}
        onClick={() => {
          props.updateIsEnabled(shouldEnable);
        }}
        size={ButtonSize.SMALL}
      />
    </Tooltip>
  );
}
